import {getModelSimpleSearch, userListToLabelEmailPhoneValue} from '../../../../Apis/functions';
import ButtonIcon from '../../../../components/buttons/ButtonIcon';
import { CleanIcon, DeliveryBoxIcon, DeliveryDocument } from '../../../../components/buttons/IconButtons';
import CustomAddChipSearch from '../../../../components/CustomAddChipSearch';
import CustomCard from '../../../../components/CustomCard';
import CustomDateTimePicker from '../../../../components/CustomDateTimePicker';
import { CustomTextField } from '../../../../components/CustomTextField';
import CustomModal from '../../../../components/Modal/CustomModal';
import { FILE_TYPE } from '../../../../Helpers/fileType';
import DeliveryModalApp from '../Functionality/DeliveryModalApp';
import React from "react";
import CustomPhotoPickerMultiple from "../../../../components/PhotoPicker/CustomPhotoPickerMultiple";
import {ACTION_MODEL} from "../../../../Helpers/ActionModel";
import {
    SERVICE_ADVANCED_SEARCH_SIMPLE_SEARCH_USER,
} from "../../../../reduxToolkit/Commons/CommonsApi";
import {TABLES} from "../../../../Apis/Tables";
/**
 *
 * @Author: Susana Garcia Rodriguez
 * @JobTitle: Frontend Developer - IBL
 * @Email: sgarcia@ibl.mx
 */
const DeliveryModal = (props) => {
    const { onHide, show, itemSelected, setModified } = props;

    const {
        t,
        handleConfirm,
        handleClear,
        photoPicker,
        setPhotoPicker,
        emptyFields,
        disabled,
        item,
        handleChange,
        selectedList,
        setSelectedList,
        supplierId
    } = DeliveryModalApp({
        onHide,
        itemSelected,
        setModified
    });

    return (
        <CustomModal
            {...props}
            size='lg'
            display={show}
            buttonConfirm='confirm'
            confirmButton={true}
            cancelButton={true}
            onConfirm={handleConfirm}
            classNameBody='m-0 p-0'
            onHide={() => {
                handleClear(ACTION_MODEL.HIDE);
                onHide();
            }}
            topLeftHeader={
                <div className='d-flex align-items-center'>
                    <DeliveryBoxIcon />
                    <p className='fs-24px ibl-font-w-600  font-color-general-950 font-color-primary-600 ml-2'>
                        {t('record_delivery')}
                    </p>
                    <div className='vertical-separator h-auto' />
                </div>
            }
        >
            <CustomCard classCard={'card-border-8px'} classContent={'p-0'}>
                <DeliveryDocument className={'w-100'} />

                <div className='mr-3 ml-3'>
                    <div className='d-flex justify-content-end mt-3 mb-3'>
                        <ButtonIcon
                            id='btn_dm_clean'
                            Icon={CleanIcon}
                            onClick={() => handleClear(ACTION_MODEL.CLEAR)}
                            emptyFields={emptyFields}
                            title={'clear_instances'}
                            className={'btn-clean-secondary-600'}
                            tooltipPlacement={'right'}
                            iconProps={'btn-icon-svg-12px icon-color-general-00'}
                        />
                    </div>
                    <CustomDateTimePicker
                        id={'dp_dm_actual_delivery_date'}
                        name={'actualDeliveryDate'}
                        disabled={disabled}
                        onChange={(e) => {
                            handleChange({ target: { value: e, name: 'actualDeliveryDate' } });
                        }}
                        trans={'date_and_time'}
                        value={item?.actualDeliveryDate}
                        required={true}
                        disablePast={false}
                        openTo={'day'}
                        emptyFields={emptyFields}
                        disableFuture={true}
                    />
                    <CustomAddChipSearch
                        autocompleteId={'slt_dm_employee'}
                        buttonId={'btn_dm_employee'}
                        selectedList={selectedList}
                        setSelectedList={setSelectedList}
                        label='received_by'
                        emptyFields={emptyFields}
                        required={true}
                        reset={false}
                        keyId={'userId'}
                        showSubSection={true}
                        sanitizeDataList={userListToLabelEmailPhoneValue}
                        api={SERVICE_ADVANCED_SEARCH_SIMPLE_SEARCH_USER}
                        bodyApi={getModelSimpleSearch(TABLES.USER_BY_SUPPLIER_ID, {userId: supplierId})}
                        completeWidth={false}
                    />
                    <div className='mb-4'>
                        <p className='ibl-font-w-700 text-uppercase text-center mb-3'>{t('provide_reason_delivery')}</p>
                    </div>
                    <CustomTextField
                        id={'txt_dm_delivery_note'}
                        length={512}
                        name={'deliveryNote'}
                        value={item?.deliveryNote}
                        emptyFields={emptyFields}
                        trans={'delivery_note'}
                        type={'text'}
                        placeholder={t('add_delivery_details')}
                        onChange={handleChange}
                        required={true}
                        multiline={true}
                    />
                    <div className='mb-4'>
                        <p className='ibl-font-w-700 text-uppercase text-center mb-3'>
                            {t('attach_evidence_required')}
                        </p>
                    </div>
                    <div className='col-12 mb-4'>
                        <CustomPhotoPickerMultiple
                            id='fu_dm_file'
                            photoPickerFile={photoPicker}
                            setPhotoPickerFile={setPhotoPicker}
                            accept={{ ...FILE_TYPE.IMAGE_FILES }}
                            showBtnDeleteItemGallery={true}
                            showBtnCamera={false}
                            required={true}
                            emptyFields={emptyFields && !photoPicker?.listFiles?.length > 0 }
                        />
                    </div>
                </div>
            </CustomCard>
        </CustomModal>
    );
};

export default DeliveryModal;
